import React from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import { twMerge } from 'tailwind-merge';
import useAppContext from 'flow/hooks/useAppContext';
import { selectNameOfOriginQueue } from 'flow/selectors/TicketsSelectors';
import { TicketKey } from 'flow/types/EntityKeys';

type Props = {
    ticketKey: TicketKey;
    muted?: boolean;
};

const SectionQueueLine = ({ ticketKey, muted }: Props) => {
    const { i18next } = useAppContext();

    const queueName = useAppSelector((state) =>
        selectNameOfOriginQueue(state, ticketKey),
    );

    if (!queueName) return null;

    return (
        <div className="flex h-6 items-center gap-1 text-sm">
            <span className="text-gray-500">{i18next.t('call.to')}</span>
            <span
                className={twMerge(
                    'min-w-0 truncate',
                    muted ? 'text-gray-500' : 'text-main',
                )}
            >
                {queueName}
            </span>
        </div>
    );
};

export default React.memo(SectionQueueLine);
